import { type PathOfBlockedRecordExamPasserFormType } from './types';

export const BLOCKED_RECORD_EXAM_PASSER_FORM_FIELD_NAME = {
  remark: 'remark',
} satisfies Record<string, PathOfBlockedRecordExamPasserFormType>;
